import {
    Auto,
    Bus,
    Ferry,
    Flight,
    Shuttle,
    Train,
} from 'wanderu-icons';

import autoIcon from '../images/auto-grey.svg';
import busIcon from '../images/bus-grey.svg';
import errorChiku from '../images/chiku-uh-oh.svg';
import ferryIcon from '../images/ferry-grey.svg';
import flightIcon from '../images/flight-grey.svg';
import bookingLogo from '../images/partners/hotels/booking-logo.svg';
import kayakLogoSmall from '../images/partners/kayak/kayak-logo-small.svg';
import kayakLogo from '../images/partners/kayak/kayak-logo.svg';
import redbusLogo from '../images/partners/redbus/redBus.png';
import heroBackground from '../images/seo/carrier-guide/hero-header.svg';
import heroMobileBackground from '../images/seo/carrier-guide/hero-mobile-header.svg';
import shuttleIcon from '../images/shuttle-grey.svg';
import trainIcon from '../images/train-grey.svg';

const partnerLogoMap = {
    booking: {
        altTag: 'Booking.com logotype',
        href: 'https://www.booking.com/',
        main: bookingLogo,
        orientation: 'wide',
    },
    kayak: {
        altTag: 'kayak logotype',
        href: 'https://www.kayak.com/',
        main: kayakLogo,
        mobile: kayakLogoSmall,
        orientation: 'wide',
    },
    redbus: {
        altTag: 'redbus logotype',
        href: 'https://www.redbus.com',
        main: redbusLogo,
        mobile: redbusLogo,
        orientation: 'square',
    },
};

const modeIconMap = {
    auto: autoIcon,
    bus: busIcon,
    ferry: ferryIcon,
    flight: flightIcon,
    shuttle: shuttleIcon,
    train: trainIcon,
};

const modeIconMapRedesign = {
    auto: Auto,
    bus: Bus,
    ferry: Ferry,
    flight: Flight,
    shuttle: Shuttle,
    train: Train,
};

export {
    errorChiku,
    heroBackground,
    heroMobileBackground,
    modeIconMap,
    modeIconMapRedesign,
    partnerLogoMap,
};
